import {
  CANCELED_IN_PRODUCTION,
  DENIED,
  ERROR_ON_SEND_TO_PRODUCTION,
  SCHEDULED_PRODUCTION,
  SENT_TO_PRODUCTION,
  WAITING_CLIENT,
  WAITING_EMEDE,
  WAITING_PHARMACEUTICAL_APPROVE,
  WAITING_TRANSCRIPTION
} from '@/settings/consts/prescription-status';

function isWaitingClient(status: string): boolean {
  return status === WAITING_CLIENT.key;
}

function isWaitingEmede(status: string): boolean {
  return status === WAITING_EMEDE.key || status === SCHEDULED_PRODUCTION.key;
}

function isWaitingTranscription(status: string): boolean {
  return status === WAITING_TRANSCRIPTION.key;
}

function isWaitingPharmaceuticalApprove(status: string): boolean {
  return status === WAITING_PHARMACEUTICAL_APPROVE.key;
}

function isSentToProduction(status: string): boolean {
  return status === SENT_TO_PRODUCTION.key;
}

function isErrorOnSentToProduction(status: string): boolean {
  return status === ERROR_ON_SEND_TO_PRODUCTION.key;
}

function isDenied(status: string): boolean {
  return status === DENIED.key || status === CANCELED_IN_PRODUCTION.key;
}

export {
  isDenied, 
  isErrorOnSentToProduction, 
  isSentToProduction, 
  isWaitingClient,
  isWaitingEmede,
  isWaitingPharmaceuticalApprove,
  isWaitingTranscription
};

